<ul class="layout-menu" *ngIf="searchCount">
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
    </ng-container>
</ul>
